import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group-card-loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "19",
  y: "0",
  rx: "4",
  ry: "4",
  width: "280",
  height: "24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "99",
  y: "48",
  rx: "4",
  ry: "4",
  width: "120",
  height: "12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "69",
  y: "64",
  rx: "4",
  ry: "4",
  width: "180",
  height: "16"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "99",
  y: "108",
  rx: "4",
  ry: "4",
  width: "120",
  height: "12"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "69",
  y: "124",
  rx: "4",
  ry: "4",
  width: "180",
  height: "16"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_content_loader, {
      viewBox: "0 0 318 130",
      speed: 1.2,
      primaryColor: "#dad9e3",
      secondaryColor: "#cecdd8"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }, 8, ["speed"])
  ]))
}